import React, { useState, useEffect, useRef, useMemo } from "react"
import { useQuery, useQueryClient } from "react-query"
import { fetchDeals } from "../../../services/main.service"
import Paginator from "../../composites/paginator"
import WithAuth from "../../hoc/with-auth"
import { LayoutWithSidebar } from "../../layouts/layout-with-sidebar.tsx"
import {
  Badge,
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Grid,
  GridItem,
  Button,
  Input,
  IconButton,
  Link as Clink,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react"
import _ from "lodash"
import BlockedLoader from "../../composites/blocked-loader"
import DateRangePicker from "../../composites/date-range-picker"
import { AiOutlineSearch } from "react-icons/ai"
import { InputWrapper } from "../../composites"
import { ReactSelect } from "../../composites/select"
import { SelectSymbols } from "../../composites/select-symbols"
import { CSVLink, CSVDownload } from "react-csv"
import { AiOutlineDownload } from "react-icons/ai"
import App from "../../../App"
import { app } from "../../../config"
import { formatDate } from "../../../utils"
import {
  getAllAccounts,
  getAllPositions,
  getAllSummaries,
} from "../../../services/crm.service"
import { AgGridReact } from "ag-grid-react"

const SummariesPage = () => {
  const [currency, setCurrency] = useState("USD")
  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
    refetch,
  } = useQuery(
    [
      "summaries",
      {
        currency,
      },
    ],
    () => getAllSummaries(currency),
    {
      refetchInterval: 4000,
    }
  )

  useEffect(() => {
    refetch()
  }, [currency])

  const gridRef = useRef<any>() // Optional - for accessing Grid's API
  const [rowData, setRowData] = useState() // Set rowData to Array of Objects, one Object per Row

  // [{"login":1000,"balance":0,"equity":0,"credit":0,"margin_used":0,"margin_level":0,"margin_free":0,"group":null},{"login":1001,"balance":0,"equity":0,"credit":0,"margin_used":0,"margin_level":0,"margin_free":0,"group":null},
  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    { headerName: "Symbol", field: "symbol" },
    { headerName: "Positions", field: "positions" },
    {
      headerName: "Buy Volume",
      field: "buyVolume",
      cellRenderer: (params: any) => {
        // @ts-ignore
        return <>{parseFloat(params?.value / 10000).toFixed(2)}</>
      },
    },
    {
      headerName: "Buy Price",
      field: "buyPrice",
      cellRenderer: (params: any) => {
        // @ts-ignore
        return <>{parseFloat(params?.value).toFixed(2)}</>
      },
    },
    {
      headerName: "Sell Volume",
      field: "sellVolume",
      cellRenderer: (params: any) => {
        // @ts-ignore
        return <>{parseFloat(params?.value / 10000).toFixed(2)}</>
      },
    },
    {
      headerName: "Sell Price",
      field: "sellPrice",
      cellRenderer: (params: any) => {
        // @ts-ignore
        return <>{parseFloat(params?.value).toFixed(2)}</>
      },
    },
    {
      headerName: "Profit",
      field: "profit",
      cellRenderer: (params: any) => {
        // @ts-ignore
        return <>{parseFloat(params?.value).toFixed(2)}</>
      },
    },
    {
      headerName: "Volume",
      field: "volume",
      cellRenderer: (params: any) => {
        // @ts-ignore
        return <>{parseFloat(params?.value).toFixed(2)}</>
      },
    },
    { headerName: "Uncovered (USD)", field: "unconveredUSD" },
  ])

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(
    () => ({
      // make every column editable
      editable: false,
      selectable: true,
      // make every column use 'text' filter by default
      filter: "agTextColumnFilter",
      // enable floating filters by default
      floatingFilter: true,
      // make columns resizable
      resizable: true,
      // disable cell data types
      cellDataType: false,
      sortable: true,
    }),
    []
  )

  return (
    <>
      <Tabs
        //align="end"
        variant="soft-rounded"
        colorScheme="blue"
        onChange={(index) => {
          switch (index) {
            case 0:
              setCurrency("USD")
              break

            case 1:
              setCurrency("POINT")
              break

            case 2:
              setCurrency("INR")
              break

            default:
              setCurrency("USD")
              break
          }
        }}
      >
        <TabList>
          <Tab>USD</Tab>
          <Tab>POINT</Tab>
          <Tab>INR</Tab>
        </TabList>
      </Tabs>

      <br />

      <div className="ag-grid-container">
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: "calc(100vh - 100px)" }}
        >
          <AgGridReact
            suppressScrollOnNewData={true}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={data?.data?.data ?? []} // Row Data for Rows
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            overlayNoRowsTemplate={
              isLoading ? "Loading summaries..." : "No  summaries found"
            }
          />
        </div>
      </div>
    </>
  )
}

export default SummariesPage
